/* 折扣码复制：原生按钮支持键盘，状态反馈兼容主题编辑器重载。 */
if (!customElements.get('lf-copy-code')) {
  customElements.define('lf-copy-code', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const button = this.querySelector('button[data-copy-code]');
      const status = this.querySelector('[role="status"]');
      if (!button || !status) return;
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          await navigator.clipboard.writeText(button.dataset.copyCode);
          status.textContent = 'Kopiert!';
          button.dataset.copied = 'true';
        } catch {
          status.textContent = 'Bitte den Code markieren und kopieren.';
        } finally {
          button.disabled = false;
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => { status.textContent = ''; delete button.dataset.copied; }, 3500);
        }
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.resetTimer); }
  });
}
